import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { WarningFilled } from "@ant-design/icons";
import { Popover } from "antd";
import DriverFatigueBreachCause from "../../enums/DriverFatigueBreachCause";
import { formatTimeWithoutSeconds } from '../../../../swzutils/DateUtil';
const DriverFatigueIcon = ({ fatigueBreaches }) => {
    if (!fatigueBreaches) {
        return null;
    }
    const breachRows = fatigueBreaches
        .filter(b => b.fixedAt === null)
        .map(b => {
        return (_jsxs("tr", { children: [_jsx("td", { children: formatTimeWithoutSeconds(b.period) }), _jsx("td", { children: DriverFatigueBreachCause.valueOf(b.cause)?.description })] }, b.id));
    });
    if (breachRows.length === 0) {
        return null;
    }
    const maxHoursBreached = fatigueBreaches.filter(b => b.cause === "MAX_HOURS").length;
    let iconColour = "#ffce3d";
    if (maxHoursBreached) {
        iconColour = "#ff0000";
    }
    return (_jsx(Popover, { content: _jsx("table", { className: "table-popover", children: _jsx("tbody", { children: breachRows }) }), title: "Driver Fatigue", children: _jsx(WarningFilled, { style: { color: iconColour } }) }));
};
export default DriverFatigueIcon;
